function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { fontSerif, fontSerifRegular, fontSemiBold } from '../../theme/fonts';
import { size8, size12, size14, size16, size18, size20, size24, size30, size36, size48 } from '../../theme/scale';
import { breakpoint } from '../../theme/breakpoints';
import ColorWrapper from '../color-wrapper';
const getSerifFontFromWeight = weight => weight === 'light' ? fontSerif : fontSerifRegular;
export const H1 = styled(ColorWrapper)`
  font-family: ${({
  weight
}) => getSerifFontFromWeight(weight)};
  font-size: ${size36};
  line-height: 1.1;
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size16};`};

  ${breakpoint.md`
    font-size: ${size48};
  `}
`;
export const H2 = styled(ColorWrapper)`
  font-family: ${({
  weight
}) => getSerifFontFromWeight(weight)};
  font-size: ${size30};
  line-height: 1.3;
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size14};`};

  ${breakpoint.md`
    font-size: ${size36};
    line-height: 1.2;
  `}
`;
export const H3 = styled(ColorWrapper)`
  font-family: ${({
  weight
}) => getSerifFontFromWeight(weight)};
  font-size: ${size24};
  line-height: 1.4;
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size8};`};

  ${breakpoint.md`
    font-size: ${size30};
    line-height: 1.2;
  `}
`;
export const H4 = styled(ColorWrapper)`
  font-family: ${fontSemiBold};
  font-size: ${size16};
  line-height: 1.5;
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size8};`};

  ${breakpoint.md`
    font-size: ${size20};
    line-height: 1.4;
  `}
`;
export const H5 = styled(ColorWrapper)`
  font-family: ${fontSemiBold};
  font-size: ${size14};
  line-height: 1.5;
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size8};`};

  ${breakpoint.md`
    font-size: ${size18};
    line-height: 1.4;
  `}
`;
export const H6 = styled(ColorWrapper)`
  font-family: ${fontSemiBold};
  font-size: ${size12};
  line-height: 1.3;
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size8};`};

  ${breakpoint.md`
    font-size: ${size16};
    line-height: 1.5;
  `}
`;
export const HEADER_VARIANTS = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6
};
export const Heading = /*#__PURE__*/forwardRef(({
  children,
  variant = 'h1',
  weight = 'light',
  marginBottom = false,
  color = 'gray900',
  element,
  ...props
}, ref) => {
  const Wrapper = HEADER_VARIANTS[variant] || HEADER_VARIANTS.h1;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: ref,
    as: element || variant,
    weight,
    marginBottom,
    color
  }, props), children);
});
export default Heading;
//# sourceMappingURL=index.js.map